import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function HomePage() {
  const user = useAuth((s) => s.user);
  return (
    <div className="mx-auto max-w-5xl px-4 py-16">
      <section className="mt-8 text-center">
        <h1 className="text-5xl font-semibold tracking-tight">
          Spend your tokens on finished work.
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg text-neutral-500">
          Your AppSumo Plus membership includes 10,000 tokens every month.
          Turn them into blog posts, thumbnails, SEO research, LinkedIn
          banners, product videos, and more — all from a curated catalog
          of SaaS partners.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to={user ? "/catalog" : "/login"}
            className="rounded-lg bg-emerald-500 px-6 py-3 font-medium text-white hover:bg-emerald-600"
          >
            {user ? "Browse the catalog" : "Log in to get started"}
          </Link>
        </div>
      </section>
    </div>
  );
}
